import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Projects = () => {
  const ref = useIntersectionObserver();

  const projects = [
    {
      title: 'AI Chat Assistant',
      desc: 'AI-powered chatbot integrated into websites and platforms for automated customer support, FAQs, and lead handling using LLM APIs.',
      image: '/images/aichatbot.png', // you can replace image
      tags: ['AI', 'LLMs', 'Automation']
    },
    {
      title: 'AI Chatbot Integration',
      desc: 'Custom AI chatbot integrations for businesses with context-aware responses, workflow automation, and backend API connectivity.',
      image: '/images/ai-chat-integration.png', // you will add image
      tags: ['AI', 'FastAPI', 'Integration']
    },
    {
      title: 'Stock Forecaster Web Application',
      desc: 'Web application for stock trend forecasting using machine learning models, historical data analysis, and interactive dashboards.',
      image: '/images/stock-forecast.png', // you will add image
      tags: ['Python', 'Machine Learning', 'Analytics']
    },
    {
      title: 'Travel Booking Platform',
      desc: 'Full-stack travel management system with booking workflows, vendor dashboards, payments, and map integrations for tour operators.',
      image: '/images/travel.webp',
      tags: ['ASP.NET', 'SQL', 'Full Stack']
    },
    {
      title: 'WordPress Websites (25+ Projects)',
      desc: 'Designed and developed 25+ WordPress websites for international clients, including business sites, e-commerce stores, and SEO-optimized landing pages.',
      image: '/images/wordpress-projects.png', // you will add image
      tags: ['WordPress', 'SEO', 'International Clients']
    },
    {
      title: 'Portfolio Website',
      desc: 'High-performance personal portfolio showcasing projects, experience, and contact integrations with modern UI design.',
      image: '/images/portfolio.jpg',
      tags: ['React', 'UI/UX']
    }
  ];

  return (
    <section id="projects" className="section">
      <div ref={ref} className="container container-lg" data-animate>
        <h2>Selected Projects</h2>

        <div className="projects-grid">
          {projects.map(project => (
            <div key={project.title} className="project">
              <img src={project.image} alt={project.title} />

              <div className="project-body">
                <h5 style={{ color: 'var(--text)', margin: '0 0 6px' }}>
                  {project.title}
                </h5>
                <p>{project.desc}</p>

                <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                  {project.tags.map(tag => (
                    <span key={tag} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Projects;
